import type {
  CsvWidgetExportAdditionalParams,
  CsvWidgetExportSource,
  ForwardCurveAdditionalParams
} from '@/features/data-hub/types/context.types';

type SourceBackedDataExportLike = {
  additionalParams?: CsvWidgetExportAdditionalParams | ForwardCurveAdditionalParams;
  sourceSettings?: {
    source: CsvWidgetExportSource;
    from?: string | null;
    to?: string | null;
    tabName?: string;
  };
};

export const isSourceBackedDataExport = (
  value: SourceBackedDataExportLike | null | undefined
): boolean => Boolean(value?.additionalParams && 'type' in value.additionalParams);
